var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { put } from 'redux-saga/effects';
import { onVehicleInfoUpdated, onVehicleIdentificationErrorUpdated, onVehicleResolved, onVssErrorUpdated } from '../actions';
import { VehicleSelectionConstants } from '../constants';
import { VehicleSelectionMethod, VehicleIdentificationErrorCode } from '../enums';
import { VehicleInfoOperations } from '../services';
function doFlyoutClicked(vehicleInfo, vehicleSelectionHierarchyLabel, vehicleSelectionMethod, vehicleInfoEntry) {
    return __awaiter(this, void 0, void 0, function* () {
        return VehicleInfoOperations.handleFlyoutClicked(vehicleInfo, vehicleSelectionHierarchyLabel, vehicleSelectionMethod, vehicleInfoEntry);
    });
}
export function* flyoutClickedAction(action) {
    const { vehicleInfo, vehicleInfoEntry, vehicleSelectionHierarchyLabel, vehicleSelectionMethod } = action.payload;
    try {
        const result = yield doFlyoutClicked(vehicleInfo, vehicleSelectionHierarchyLabel, vehicleSelectionMethod || vehicleInfo.VehicleSelectionMethod, vehicleInfoEntry);
        if (result.ErrorCode || result.Error) {
            const { ErrorCode, Error } = result, restResult = __rest(result, ["ErrorCode", "Error"]);
            yield put(onVssErrorUpdated(Object.assign(Object.assign({}, restResult), { error: Error, errorCode: ErrorCode })));
            //hydrate the vehicle info data for vehicle selection clear out the data based on
            //vehicle selection hierarchy if VSS API throws while flyout clicked
            const hydratedVehicleInfo = VehicleInfoOperations.hydrateFlyoutClickedErroredResponse(vehicleSelectionHierarchyLabel, restResult);
            yield put(onVehicleInfoUpdated(hydratedVehicleInfo));
        }
        else {
            //We are not in an error state so clear any existing error
            yield put(onVssErrorUpdated({}));
            if (result.Types &&
                result.Types.length === 1 &&
                (result.Types[0].Id === VehicleSelectionConstants.genericDecodeTypeIds[0] ||
                    result.Types[0].Id === VehicleSelectionConstants.genericDecodeTypeIds[1])) {
                result.VehicleSelectionMethod = VehicleSelectionMethod.GenericVehicle;
            }
            yield put(onVehicleInfoUpdated(result));
            if (result.Vehicle && result.Vehicle.Id !== undefined && result.Vehicle.Id !== null) {
                yield put(onVehicleResolved(result));
            }
        }
    }
    catch (e) {
        yield put(onVehicleIdentificationErrorUpdated({
            errorCode: VehicleIdentificationErrorCode.SelectionFailure,
            errorPayload: {
                vehicleInfo: vehicleInfo,
                vehicleInfoEntry: vehicleInfoEntry,
                vehicleSelectionHierarchyLabel: vehicleSelectionHierarchyLabel,
                vehicleSelectionMethod: vehicleSelectionMethod || vehicleInfo.VehicleSelectionMethod
            }
        }));
    }
}
//# sourceMappingURL=flyoutClicked.js.map